import { render } from "./a-propos.vue?vue&type=template&id=2efe021e&scoped=true"
import script from "./a-propos.vue?vue&type=script&lang=js"
export * from "./a-propos.vue?vue&type=script&lang=js"

import "./a-propos.vue?vue&type=style&index=0&id=2efe021e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efe021e"]])

export default __exports__